module.exports = __webpack_public_path__ + "img/art_7_7.f2f05582.png";